import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, Link ,useNavigate} from 'react-router-dom';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';
import './style.css';

function App() {

    const location = useLocation();
    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get(param);
    };
    
    const orderId = getQueryParam('id');

    const [getData, setGetData] = useState('');
	const [productData, setProductData] = useState([]);
	const [qty, setQty] = useState(1);
	const [selectedProduct, setProduct] = useState('');
	const [cartItems, setCartItems] = useState([]);
	const [total, setTotal] = useState(0);
	const [gst, setGST] = useState(0);
	const [error, setError] = useState('');
	const [isVisible, setIsVisible] = useState(true);

    const getdata = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/orders/order-details/',{orderId: orderId}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
		
            console.log(response.data);

			if(response.data.status === 'success'){
				setGetData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};

	const getProducts = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/products/all-product/', {}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

			//console.log(response.data);

			if(response.data.status === 'success'){
				setProductData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};


	function triggerError() {
		setTimeout(() => {
			setError('');
		}, 2000);
	}

	const getCart = () => {
		const cartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
		setCartItems(cartItems);

		let total = 0;
		let gst = 0;
		cartItems.forEach(item => {
			total += parseFloat(item.price) * parseFloat(item.qty)
			gst += (item.price - (item.price / (1 + parseFloat(item.gst) / 100)) ) * parseFloat(item.qty);
		});

		setTotal(total);
		setGST(gst);
	};


	const addCart = () => {

		if(selectedProduct === '' || !selectedProduct){
			setError('Please select product');
			triggerError();
		}else{

			if(qty === 0 || !qty){
				setError('Please select quantity atleast 1');
				triggerError();
			}else{

				const existingCartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
				const existingItemIndex = existingCartItems.findIndex(item => item.product === selectedProduct);

				if (existingItemIndex !== -1) {
			
					const newQty = Number(existingCartItems[existingItemIndex].qty) + Number(qty);
					if (!isNaN(newQty) && newQty > 0) {
						existingCartItems[existingItemIndex].qty = newQty;
					} else {
						console.log("Invalid quantity");
					}
				}else{

					const product = productData.find((product) => product.id === selectedProduct);
					const price = product ? product.productPrice : null;
					const name = product ? product.productName : null;
					const productWeight = product ? product.productWeight : null;
					const productUnit = product ? product.unit : null;
					const productGst = product ? product.productGst : null;

					const newItem = {
						product: selectedProduct,
						qty: qty,
						price: price,
						name: name,
						weight: productWeight,
						unit: productUnit,
						gst: productGst
					};

					existingCartItems.push(newItem);
				}

				sessionStorage.setItem('cartItems', JSON.stringify(existingCartItems));
				getCart();
			}
		}
		setQty(0);
	};

	const removeItem = (id) => {
		const updatedCartItems = cartItems.filter(item => item.product !== id);
		sessionStorage.setItem('cartItems', JSON.stringify(updatedCartItems));
		getCart();
	};

	const changeQty = (e) => {
		const qtys = e.target.value;
		setQty(qtys);
	};



	const changeQtyBtn = (calc) => {
		if(calc === 'plus'){
			setQty(Number(qty)+1);
		}else{
			if(qty === 0){
				setQty(qty);
			}else{
				setQty(Number(qty)-1);
			}
		}
	};

	const addDisplay = () => {
		setIsVisible(!isVisible);
	};

	const placeOrder = async () => {
		const orderData = {
			dealerId: orderId,
			total: total,
			gst: gst,
			items: cartItems
		}

		try {
			const response = await axios.post('https://api.trucoo.in/dealers/add-items/', orderData, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

			console.log(response.data);

			if(response.data.status === 'success'){
				sessionStorage.removeItem('cartItems');
				getCart();
				setQty(0);
				setGST('');
				setTotal('');
				getdata();
				setIsVisible(!isVisible);
				alert('Items added to distributer!');
			}
		  } catch (error) {
			console.error(error);
		  }
	};


	useEffect(() => {
		getdata();
		getProducts();
		getCart();
	},[]);

	const calculateTotals = () => {
    let totalCrates = 0;
    let totalLiters = 0;
    let totalAmount = 0;
    let totalQty = 0;

    if (getData?.orderData) {
        getData.orderData.forEach(item => {
            const qty = Number(item.qty);
            const weight = Number(item.weight);
            const crate = Number(item.crates);
            const amount = Number(item.subtotal);

            totalCrates += qty;
            totalQty += qty * crate;
            totalLiters += (qty * crate * weight) / 1000;
            totalAmount += amount;
        });
    }
    return {
        totalCrates: totalCrates.toFixed(2),
        totalLiters: totalLiters.toFixed(2),
        totalAmount: totalAmount.toFixed(2),
        totalQty: totalQty.toFixed(2)
    };
};

const { totalCrates, totalLiters, totalAmount, totalQty } = calculateTotals();


const formatViewDate = (date) => {
    const newDate = new Date(date);
    if (isNaN(newDate)) {
      //console.error("Invalid date format");
      return;
    }

    const formattedDate = `${String(newDate.getDate()).padStart(
      2,
      "0"
    )}-${String(newDate.getMonth() + 1).padStart(
      2,
      "0"
    )}-${newDate.getFullYear()}`;
    return formattedDate;
  };


  	let crates = 0;
	let qtyValue = 0;
	let weight = 0;
	let totalValue = 0;
	let gstValue = 0;

return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
			<div class="box">
				<div class="box-header with-border">
				  <h4 class="box-title">{getData?.type === 'challan' ? 'Delivery Challan' : 'Invoice Data'}</h4>
				  <p class="mb-0 box-subtitle">Order Details</p>
				</div>
				<div class="box-body">
                    <div class="row mb-4">
						<div class="col-xxl-12 col-xl-12 col-lg-12 col-md-6 col-12">
                            <div class="space-between">
							{isVisible ? <>
								<div>
                                        <h6>Invoice To</h6>
                                        <small> <b>{getData?.dealerData?.dealer}</b><br />
                                            {getData?.dealerData?.name}<br /> {getData?.dealerData?.address}<br />
                                            {getData?.dealerData?.gst}, {getData?.dealerData?.phone}, {getData?.dealerData?.email}
                                        </small> 

                                        <h6 class="mt-4">Ships To</h6>
                                        <small> <b>{getData?.shipping?.company}</b><br />
                                            {getData?.shipping?.address}<br />
                                            {getData?.shipping?.phone}, {getData?.shipping?.email}
                                        </small> 

                                        <h6 class="mt-4">Dispatch From</h6>
                                        <small> <b>{getData?.dispatchAddress?.company}</b><br />
                                            {getData?.dispatchAddress?.address}<br />
                                            {getData?.dispatchAddress?.phone}, {getData?.dispatchAddress?.email}
                                        </small> 
                                       
								</div>
								<div align="left">
									<table width="100%">
                                        <tr>
                                            <td style={{padding: '5px'}}>Amount</td>
                                            <td style={{padding: '5px'}}>₹ {parseFloat(totalAmount).toFixed(2)}</td>
                                        </tr>
										<tr>
                                            <td style={{padding: '5px'}}>Date</td>
                                            <td style={{padding: '5px'}}>{formatViewDate(getData?.orderDate)}</td>
                                        </tr>
                                        <tr>
                                            <td style={{padding: '5px'}}>Zone</td>
                                            <td style={{padding: '5px'}}>{getData?.dealerData?.zoneData?.zone}</td>
                                        </tr>
                                        <tr>
                                            <td style={{padding: '5px'}}>Route</td>
                                            <td style={{padding: '5px'}}>{getData?.dealerData?.routes}</td>
                                        </tr>
                                        <tr>
                                            <td style={{padding: '5px'}}>Place</td>
                                            <td style={{padding: '5px'}}>{getData?.dealerData?.locations}</td>
                                        </tr>
                                        <tr>
                                            <td style={{padding: '5px'}}>Vehicle No</td>
                                            <td style={{padding: '5px'}}>{getData?.vNum}</td>
                                        </tr>
                                        <tr>
                                            <td style={{padding: '5px'}}>E-Way Bill</td>
                                            <td style={{padding: '5px'}}>{getData?.eWayNum}</td>
                                        </tr>
                                    </table>
								</div>
								<div align="right">
									{/* <button class="btn btn-primary" onClick={addDisplay}>Add Items</button> <br /> */}
									{getData?.type === 'challan' ? 
										<a class="btn btn-success mt-2" href={`/create-challans?id=${orderId}`}>Create Invoice</a>
									:
										<a class="btn btn-success mt-2" href={`/daily-invoice?id=${orderId}`}>Create Invoice</a>
									}
									{/* <a class="btn btn-warning mt-2" href={`/dealer-incentive?id=${orderId}`}>Incentive</a> */}
								</div>
							</> : <>
								<div style={{minWidth: 'calc(100% - 370px)'}}>
								    <h4 class="box-title text-primary mb-0"><i class="ti-save me-15"></i>Order Info</h4>
								    <hr class="my-15" />
									{cartItems.length > 0 ?
										<table class="table">
											<thead>
												<tr>
													<th width="40%">Product</th>
													<th width="10%">Qty</th>
													<th width="15%">Unit Price</th>
													<th width="15%">Ltr</th>
													<th width="20%">Total</th>
													<th width="15%">Actions</th>
												</tr>
											</thead>
											<tbody>
												{cartItems?.map((product, index) => 
												<tr>
													<td>{product.name}</td>
													<td>{parseFloat(product.qty).toFixed(2)}</td>
													<td>{Number(product.price).toFixed(2)}</td>
													<td>{(parseFloat(product.qty) * parseFloat(product.weight) / 1000).toFixed(2)}</td>
													<td>{(Number(product.price) * Number(product.qty)).toFixed(2)}</td>
													<td class="table-action min-w-100">
														<button class="form-control text-fade hover-primary" onClick={() => removeItem(product.product)}><i class="fa fa-trash"></i></button>
													</td>
												</tr>
												)}
												<tr>
													<td colspan="4"></td>
													<td >Sub Total</td>
													<td style={{textAlign: 'right'}}>{Number(total-gst).toFixed(2)}</td>
												</tr>
												<tr>
													<td colspan="4"></td>
													<td >GST</td>
													<td style={{textAlign: 'right'}}>{Number(gst).toFixed(2)}</td>
												</tr>
												<tr>
													<td colspan="4"></td>
													<th  >Grand Total</th>
													<th  style={{textAlign: 'right'}}>{Number(total).toFixed(2)}</th>
												</tr>
											</tbody>
										</table>
										:
										<div align="center" class="mt-4 mb-4"> <p>Add Items</p></div>
										}
										
								
						
							
						</div>

						<div  style={{maxWidth: '350px'}}>
							<div class="row">
											<div class="col-md-12">
												<div class="form-group">
													<label class="form-label">Select Product</label>
													<select className="form-select" name="product" valu={selectedProduct} onChange={(e)=> setProduct(e.target.value)} required >
														<option value="" hidden>Select Product</option>
														{productData?.map((product, index) => 
															<option value={product.id}>{product.productName}</option>
														)}
													</select>
												</div>
											</div>
											<div class="col-md-8">
												<div class="form-group">
													<label class="form-label">Quantity</label>
													<div class="input-group">
														<button type="button" class="btn btn-info btn-sm" style={{padding: '5px 25px'}} onClick={()=> {changeQtyBtn('minus')}}>-</button>
														<input type="number" class="form-control" style={{textAlign: 'center'}} name="phone" value={qty} onChange={changeQty} required />
														<button type="button" class="btn btn-info btn-sm" style={{padding: '5px 25px'}} onClick={()=> {changeQtyBtn('plus')}}>+</button>
													</div>
												</div>
											</div>
											<div class="col-md-4 mt-4" align="right">
												<button type="button" class="btn btn-primary btn-sm mt-2" style={{padding: '6px 25px'}} onClick={addCart}>+</button>
											</div>
											{error && <p class="text-danger">{error}</p> }
											<hr />
											<div class="col-md-4 mt-4" >
												<button type="button" class="btn btn-danger btn-sm mt-4" style={{padding: '6px 25px'}} onClick={addDisplay}>cancel</button>
											</div>
											<div class="col-md-8 mt-4" align="right">
												<button type="button" class="btn btn-success btn-sm mt-4" style={{padding: '6px 25px'}} onClick={placeOrder}>Add New Items</button>
											</div>
											
							</div>
                            </div>
							</>
}
                            </div>
                        </div>
                    </div>

					{getData?.remarks?.length > 0 && (
						<>
							<div class="box-header with-border">
				                <p class="mb-0 box-subtitle">Notes</p>
				            </div>
				            <div class="box-body" style={{padding: '30px', border: '1px solid #000', borderRadius: '10px'}}>
								<p class="text-danger text-bold">{getData?.remarks}</p>
							</div>
						</>
					)}
					<div class="box-header with-border">
				                <p class="mb-0 box-subtitle">Order Items</p>
				            </div>
				            <div class="box-body">
					            <div class="table-responsive">
					                <table className="table-sm table-bordered fs-12" width="100%">
						                <thead>
							                <tr class="text-dark">
								                <th width="5%">S.No</th>
								                <th>Item</th>
								                <th>Input</th>
								                <th class="text-end">Cartes</th>
								                <th class="text-end">Qty</th>
								                <th class="text-end">L/KGs</th>
								                <th class="text-end">Price</th>
								                <th class="text-end">GST</th>
								                <th class="text-end">Amount</th>
							                </tr>
                                        </thead>
						                <tbody>
							                {getData ? getData?.orderData.map((item, index) =>{
												
												const price = parseFloat(item.price);
                                                const gst = parseFloat(item.gst);
                                                const productGst = parseFloat(price - ( price / (1+ gst/100) ));
                                                const productPrice = parseFloat(price - productGst);
                                                const rate = parseFloat(productPrice.toFixed(2) * parseFloat(item.qty) * parseFloat(item.crates)).toFixed(2);
                                                const gstRate = rate * (parseFloat(item.gst)/100);
                                                const gstRate2 = parseFloat(gstRate / 2).toFixed(2);

												crates += parseFloat(item.qty);
                                                qtyValue += parseFloat(parseFloat(item.qty) * parseFloat(item.crates));
                                                weight += (parseFloat(item.qty) * parseFloat(item.crates) *  parseFloat(item.weight) / 1000);
                                                totalValue += (parseFloat( parseFloat(rate) + parseFloat(gstRate2) + parseFloat(gstRate2)));
                                                gstValue += (parseFloat(parseFloat(gstRate2) + parseFloat(gstRate2)));

												return (
													<tr key={index}>
														<td>{index+1}</td>
														<td class="text-dark">{item.itemName}</td>
														<td class="text-dark">{item.inputs}</td>
														<td class="text-end">{parseFloat(item.qty).toFixed(2)}</td>
														<td class="text-end">{(parseFloat(item.qty) * parseFloat(item.crates)).toFixed(2)}</td>
														<td class="text-end">{(parseFloat(item.qty) * parseFloat(item.crates) *  parseFloat(item.weight) / 1000).toFixed(2)}</td>
														<td class="text-end">₹ {parseFloat(productPrice).toFixed(2)}</td>
                                                        <td class="text-end">₹ {parseFloat(parseFloat(gstRate2) + parseFloat(gstRate2)).toFixed(2)}</td>
                                                        <td class="text-end">₹ {parseFloat( parseFloat(rate) + parseFloat(gstRate2) + parseFloat(gstRate2)).toFixed(2)}</td>
													</tr>
							                	)}
											):(
								                <tr>
									                <td colSpan={6}>No Order Details Data</td>
								                </tr>
							                )}
							
						                </tbody>	
                                        <tfoot>
                                            <tr class="text-dark fw-bold">
                                                <td colSpan="3" class="text-start">Total</td>
                                                <td class="text-end">{parseFloat(crates).toFixed(2)}</td>
                                                <td class="text-end">{parseFloat(qtyValue).toFixed(2)}</td>
                                                <td class="text-end">{parseFloat(weight).toFixed(2)}</td>
                                                <td></td>
                                                <td class="text-end">{parseFloat(gstValue).toFixed(2)}</td>
                                                <td class="text-end">₹ {parseFloat(totalValue).toFixed(2)}</td>
                                            </tr>
                                        </tfoot>

					                </table>
					            </div>              
				            </div>       
				</div>
			  </div>
			</section>
		</div>
	</div>

	<Footer />
</>
);
}

export default App;